import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "../Aibox/AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addHikvision, addSigfoxAPI, aiboxLogin, hikvisionLogin, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/pleasewait.json'
import fail from '../../../../../../assets/animations/fail.json'
import success from '../../../../../../assets/animations/success.json'
import SelectableListRow from '../SelectableListRow';
import { Dialog } from 'primereact/dialog';


const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const HikvisionForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to Hikvision, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);

    const [failReason, setFailReason] = useState("")

    const [availableEvents, setAvailableEvents] = useState([])
    const [selectedEvents, setSelectedEvents] = useState([])

    const [availableChannels, setAvailableChannels] = useState([])
    const [selectedChannels, setSelectedChannels] = useState([])

    // Helper list only - thermal channels are a subset of availableChannels, used to decide
    // which channels to offer once "Thermal Perimeter Rules" (behaviorRule) is among selectedEvents.
    const [availableThermalChannels, setAvailableThermalChannels] = useState([])

    const [availableIOOutputs, setAvailableIOOutputs] = useState([])
    const [selectedOutputIds, setSelectedOutputIds] = useState([])

    const RELAY_CATEGORY = "Alarm outputs"
    const [selectedControlOptions, setSelectedControlOptions] = useState([])

    const [loggingIn, setLoggingIn] = useState(false)
    const [failed, setFailed] = useState(false)


    const [title, setTitle] = useState("Link Hikvision")

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    const handleEventSelected = (event) => {
        setSelectedEvents((prevSelectedEvents) => {
            if (prevSelectedEvents.includes(event)) {
                return prevSelectedEvents.filter(
                    (selectedEvent) => selectedEvent !== event
                );
            } else {
                return [...prevSelectedEvents, event];
            }
        });
    };

    const handleChannelSelected = (channel) => {
        setSelectedChannels((prevSelectedChannels) => {
            if (prevSelectedChannels.includes(channel.id)) {
                return prevSelectedChannels.filter(
                    (selectedChannel) => selectedChannel !== channel.id
                );
            } else {
                return [...prevSelectedChannels, channel.id];
            }
        });
    };

    const handleOutputSelected = (output) => {
        setSelectedOutputIds((prevSelected) => {
            if (prevSelected.includes(output.id)) {
                return prevSelected.filter((id) => id !== output.id);
            } else {
                return [...prevSelected, output.id];
            }
        });
    };

    // A pin is either events-based or a relay (alarm output) - picking the relay category
    // clears any event-group selection and vice versa, they can't be combined.
    const HandleControlOptionSelected = (option) => {
        setSelectedControlOptions((prevSelected) => {
            if (option === RELAY_CATEGORY) {
                return prevSelected.includes(RELAY_CATEGORY) ? [] : [RELAY_CATEGORY];
            }
            const withoutRelay = prevSelected.filter((x) => x !== RELAY_CATEGORY);
            return withoutRelay.includes(option)
                ? withoutRelay.filter((x) => x !== option)
                : [...withoutRelay, option];
        });
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };


    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        if (availableEvents.length > 0 || availableIOOutputs.length > 0){
            setModalPageIndex(13)
        }
    }, [availableEvents, availableIOOutputs])

    // Event groups are whatever the login response actually returns (group/groupLabel per
    // event) - e.g. "optical" (Camera detection), "thermal_perimeter" (behaviorRule), "inputs" (IO).
    const eventGroups = Array.from(
        new Map(availableEvents.map((event) => [event.group, event.groupLabel || event.group])).entries()
    ).map(([group, groupLabel]) => ({ group, groupLabel }))

    const isRelayMode = selectedControlOptions.includes(RELAY_CATEGORY)

    // Physical inputs are wired to the NVR itself, not to a camera channel - unlike optical/
    // thermal events, they're not scoped to specific channels at all.
    const NO_CHANNEL_GROUPS = new Set(["inputs"])
    const requiresChannelSelection = selectedControlOptions.some((group) => group !== RELAY_CATEGORY && !NO_CHANNEL_GROUPS.has(group))

    const thermalChannelIds = new Set(availableThermalChannels.map((channel) => channel.id))
    const includesThermalGroup = selectedControlOptions.includes("thermal_perimeter")
    const includesNonThermalGroup = selectedControlOptions.some((group) => group !== "thermal_perimeter" && !NO_CHANNEL_GROUPS.has(group) && group !== RELAY_CATEGORY)
    const channelChoices = availableChannels.filter((channel) => {
        const isThermal = thermalChannelIds.has(channel.id)
        return (isThermal && includesThermalGroup) || (!isThermal && includesNonThermalGroup)
    })

    const HandleControlOptionsNext = () => {
        setModalPageIndex(isRelayMode ? 15 : 10)
    }

    const renderControlOptionCard = (key, title, description) => (
        <div
            key={key}
            style={{
                display: "flex", alignItems: "center", gap: "14px", padding: "14px 18px",
                border: `2px solid ${selectedControlOptions.includes(key) ? "var(--Primary-Color)" : "#e0e0e0"}`,
                borderRadius: "8px", cursor: "pointer",
            }}
            onClick={() => HandleControlOptionSelected(key)}
        >
            <div style={{
                width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                border: `2px solid ${selectedControlOptions.includes(key) ? "var(--Primary-Color)" : "#ccc"}`,
                background: selectedControlOptions.includes(key) ? "var(--Primary-Color)" : "white",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}>
                {selectedControlOptions.includes(key) && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
            </div>
            <div>
                <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>{title}</p>
                <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>{description}</p>
            </div>
        </div>
    )

    const HandleLogin = async () => {
        setMessage("")
        //setModalPageIndex(3)
        setLoggingIn(true)
        //Change this to display within the same dialog so details arent erased for editing
        let loginBody = {
            "protocol": "http",
            "hostName": ipAddressState.value,
            "port": portState.value,
            "username": usernameState.value,
            "password": passwordState.value,
            "userID": userID
        }

        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 15_000)

        try {
            const loginResponse = await hikvisionLogin(
                apiData,
                loginBody,
                dispatch,
                controller.signal
            )

            console.log(loginResponse);
            
            if (loginResponse.success) {
                setLoggingIn(false)
                // Fallback for older backends that don't send `label`/`group` yet.
                const nameMap = {
                    "IO": "Alarm Input (Physical)",
                    "linedetection": "Line Crossing",
                    "fielddetection": "Intrusion Detection",
                    "VMD": "Motion Detection",
                    "behaviorRule": "Thermal Perimeter Rules",
                    "regionentrance": "Region Entrance",
                    "regionexiting": "Region Exiting"
                }
                // Hidden for now - fire/temperature events aren't exposed in the picker yet,
                // though arm/disarm still works if an older pin already has them configured.
                const HIDDEN_EVENT_TYPES = new Set(["thermometry", "tmpa", "temperature", "temperatureintervalmeasurement"])
                const renamedEvents = loginResponse.data
                    .filter(event => !HIDDEN_EVENT_TYPES.has(event.eventType))
                    .map(event => ({
                        ...event,
                        displayName: event.label ?? nameMap[event.eventType] ?? event.eventType,
                        group: event.group ?? "other",
                        groupLabel: event.groupLabel ?? "Other events"
                    }))
                setAvailableEvents(renamedEvents)
                setAvailableChannels(loginResponse.channels)
                //setAvailableThermalChannels(loginResponse.thermalChannels)
                setAvailableIOOutputs(loginResponse.ioOutputs)
            } else {
                //setModalPageIndex(11)
                setLoggingIn(false)
                setFailed(true)
                setFailReason("Failed to login to Hikvision, please check your credentials & try again")
            }
        } catch (err) {
            //setModalPageIndex(11)
            setLoggingIn(false)
            setFailed(true)
            if (err.name === "AbortError") {
                setFailReason("Login timed out. Please check your login credentials and try again.")
            } else {
                setFailReason("An unexpected error occurred. Please try again.")
            }
        } finally {
            setLoggingIn(false)
            clearTimeout(timeoutId)
        }
    }


    const HandleLink = async () => {
        const fullIP = `${ipAddressState.value}:${portState.value}`
        // A pin is either events-based or a relay - extraField2 stores whichever one applies,
        // so eventsToHandle carries a relay control object instead of events when in relay mode.
        const body = {
            pinNumber: pinSelected,
            siteUUID: DeviceUUID,
            userID: userID,
            ipAndPort: fullIP,
            eventsToHandle: isRelayMode
                ? [{ controlLevel: "alarm_output", outputIds: selectedOutputIds }]
                : selectedEvents,
            channelIds: (isRelayMode || !requiresChannelSelection) ? null : selectedChannels
        }

        console.log(body);

        const response = await addHikvision(apiData, body, dispatch)
        if (response.success){
            //HandleCloseModal();
            setModalPageIndex(8)
        } else {
            //HandleCloseModal();
            setModalPageIndex(11);
            setFailReason("Failed to link Hikvision, please try again")
        }
    }


    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setTitle("Link Hikvision")
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link the Hikvision to?</h3>
                        <br></br>
                        <small style={{color:"#6e6e6e"}}>Please make sure the Hikvision and your selected output are set to the same state.</small>                        
                        <small style={{color:"#6e6e6e"}}>If they are different, the first command will only be used to sync them and</small>
                        <small style={{color:"#6e6e6e"}}>will NOT change the Hikivision.</small>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Hikvision Login</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your account by completing the fields below</p>

                            <br></br>
                            <small style={{color:"#6e6e6e"}}>Please do not include 'https://' or port in the IP Address</small>
                            <br></br>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"HTTP Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button  icon="pi pi-user" severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
                break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button  icon="pi pi-times"severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )
                HandleShowModal();
                break; 
            case 3: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Hikvision</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 450, height: 450, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                   
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>Hikvision linked successfully!</h3>
                    </div>

                    <br></br>
                     <Lottie
                        animationData={success}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                    
                    <div>
                        <br></br>
                        <Button 
                            onClick={() => {HandleCloseModal(); fetchVirtualSources();}} 
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                             icon="pi pi-times"
                        />
                    </div>
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={fail} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Failed to link Hikvision</h3>
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failReason}</h3>
                    <br />
                    <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
                </div>
            )
            HandleShowModal();
        break; 
        case 10:
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the events to control below</h3>
                    <br/>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {availableEvents
                            .filter(event => selectedControlOptions.includes(event.group))
                            .map((event, index) => (
                                <SelectableListRow
                                    key={index}
                                    selected={selectedEvents.includes(event)}
                                    label={event.displayName}
                                    onClick={() => handleEventSelected(event)}
                                />
                            ))
                        }
                    </div>
                    <br/>

                    <Button
                        label={requiresChannelSelection ? "Next" : "Link Hikvision"}
                        severity="success"
                         icon="pi pi-check"
                        disabled={selectedEvents.length == 0}
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => requiresChannelSelection ? setModalPageIndex(12) : HandleLink()}
                    />
                    <Button
                        label={"Back to options"}
                        severity="danger" outlined
                        icon="pi pi-chevron-left"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => setModalPageIndex(13)}
                    />
                </div>
            )
        break;
        case 11:
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Failed to login</h3>
                    <br/>
                    <Lottie
                        animationData={fail}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />

                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>{failReason}</p>
                    <br/>
                    <Button  icon="pi pi-times" label='Close' severity='secondary' onClick={HandleCloseModal}/>
                </div>
            )

            HandleShowModal();
            break;
        case 12:
            setModalComponent(
                 <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the channels to control below</h3>
                    <br/>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {channelChoices.map((channel, index) => (
                            <SelectableListRow
                                key={index}
                                selected={selectedChannels.includes(channel.id)}
                                label={channel.name}
                                onClick={() => handleChannelSelected(channel)}
                            />
                        ))}
                    </div>
                    <br/>

                    <Button
                        label={"Link Hikvision"}
                        severity="success"
                         icon="pi pi-check"
                        disabled={selectedChannels.length == 0}
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink()}
                    />
                    <Button
                        label={"Back to options"}
                        severity="danger" outlined
                        icon="pi pi-chevron-left"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => setModalPageIndex(13)}
                    />
                </div>
            )
        break;
        case 13:
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <h3 style={{color:"#6e6e6e"}}>What would you like to control?</h3>
                    <br/>
                    <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        {eventGroups.map(({ group, groupLabel }) =>
                            renderControlOptionCard(group, groupLabel, "Trigger actions from Hikvision events in this group")
                        )}
                        {availableIOOutputs.length > 0 && renderControlOptionCard(RELAY_CATEGORY, "Alarm Outputs", "Control the status of physical alarm output relays")}
                    </div>
                    <br/>
                    <Button
                        label={"Next"}
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        severity="success"
                        disabled={selectedControlOptions.length == 0}
                        onClick={() => HandleControlOptionsNext()}
                    />
                </div>
            )
            HandleShowModal();
        break;
        case 15:
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the alarm outputs to control below</h3>
                    <br/>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {availableIOOutputs.length > 0 &&
                            availableIOOutputs.map((output, index) => (
                                <SelectableListRow
                                    key={index}
                                    selected={selectedOutputIds.includes(output.id)}
                                    label={output.ioType ? `${output.id} (${output.ioType})` : output.id}
                                    onClick={() => handleOutputSelected(output)}
                                />
                            ))
                        }
                    </div>
                    <br/>

                    <Button
                        label={"Link Hikvision"}
                        severity="success"
                         icon="pi pi-check"
                        disabled={selectedOutputIds.length == 0}
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink()}
                    />
                    <Button
                        label={"Back to options"}
                        severity="danger" outlined
                        icon="pi pi-chevron-left"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => setModalPageIndex(13)}
                    />
                </div>
            )
            HandleShowModal();
        break;
        }
    }, [modalPageIndex, ipAddressState, portState, usernameState, passwordState, linkMessage, linkTitle, message, failReason, selectedEvents, selectedChannels, selectedOutputIds, selectedControlOptions]);

    return (
        <>
            <Modal ref={ModalDialog} title={title} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <Dialog
                header="Logging in"
                visible={loggingIn}
                style={{ width: "25vw" }}
                onHide={() => setLoggingIn(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Hikvision</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 450, height: 450, margin: "0px" }}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Failed"
                visible={failed}
                style={{ width: "25vw" }}
                onHide={() => setFailed(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Failed to login</h3>
                    <br/>
                    <Lottie
                        animationData={fail}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />

                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px", alignContent:"center", display:"flex"}}>{failReason}</p>
                    <br/>
                    <Button  icon="pi pi-times" label='Close' severity='secondary' onClick={() => setFailed(false)}/>
                </div>
            </Dialog>
        </>
    )
}

export default HikvisionForm;